import { movies } from "@/mocks/movies";
import { trending } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function Trending() {
  return (
    <section id="trending" className="bg-secondary-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="热门电影"
          title="最近大家都在聊的几部"
          description="热度不等于质量，但能反映当下的观看风向。想知道朋友圈和评论区在讨论什么，看这一栏就够了。"
        />

        <div className="no-scrollbar mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2">
          {trending.map((item) => {
            const movie = movies.find((m) => m.id === item.movieId);
            if (!movie) return null;
            return (
              <article
                key={item.movieId}
                className="w-[280px] shrink-0 snap-start overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <div className="flex gap-3 p-4">
                  <div className="h-[104px] w-[74px] shrink-0 overflow-hidden rounded-md bg-background-100">
                    <img
                      src={movie.poster}
                      alt={`${movie.title} 电影海报`}
                      title={`${movie.title} 热门电影海报`}
                      className="h-full w-full object-top object-cover"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <span className="inline-flex rounded-full bg-accent-100 px-2 py-0.5 font-label text-[11px] font-medium text-accent-800">
                      {item.trendLabel}
                    </span>
                    <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
                      {movie.title}
                    </h3>
                    <p className="mt-0.5 font-label text-xs text-foreground-600">
                      {movie.genre} · {movie.year}
                    </p>
                    <p className="mt-1 flex items-center gap-1 font-label text-xs font-medium text-accent-600">
                      <i className="ri-star-fill text-[10px]"></i>
                      {movie.rating.toFixed(1)}
                    </p>
                  </div>
                </div>
                <div className="px-4 pb-4">
                  <div className="flex items-center justify-between font-label text-[11px] text-foreground-500">
                    <span>讨论热度</span>
                    <span>{item.heat}%</span>
                  </div>
                  <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-secondary-500"
                      style={{ width: `${item.heat}%` }}
                    ></div>
                  </div>
                  <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {movie.tagline}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
        <p className="mt-3 flex items-center gap-1.5 font-label text-xs text-secondary-800">
          <i className="ri-drag-move-2-line"></i>
          左右滑动查看更多热门作品
        </p>
      </div>
    </section>
  );
}